import styled from "styled-components";

export default styled.div`
  -webkit-tap-highlight-color: transparent;

  .logo {
    margin-top: 2px;
  }
  .navbar-burger {
    &:hover {
      background-color: transparent;
    }
  }
`;
